var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTzBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "900px",
    height: "900px",
    viewBox: "0 0 900 900",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-8",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F6F8FA",
    cx: 450,
    cy: 450,
    r: 450
  }), /*#__PURE__*/React.createElement("g", {
    id: "tzBTC_filled_logo-copy-2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    fill: "#1459FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M864.0635,274.6553 C841.4131,221.1031 808.9898,173.0108 767.6944,131.7158 C726.399,90.4204 678.3072,57.9966 624.7549,35.3462 C569.3037,11.8921 510.4082,0 449.7051,0 C389.002,0 330.1065,11.8921 274.6548,35.3462 C221.1026,57.9966 173.0108,90.4204 131.7153,131.7158 C90.4199,173.0107 57.9965,221.103 35.3457,274.6553 C11.8916,330.1064 0,389.002 0,449.7051 C0,510.4082 11.8916,569.3037 35.3457,624.7554 C57.9961,678.3076 90.4199,726.3994 131.7153,767.6949 C173.0107,808.9904 221.1025,841.4137 274.6548,864.0645 C330.1065,887.5181 389.0015,899.4102 449.7051,899.4102 C510.4087,899.4102 569.3037,887.5181 624.7549,864.0645 C678.3071,841.4136 726.3989,808.9903 767.6944,767.6949 C808.9899,726.3995 841.4132,678.3077 864.0635,624.7554 C887.5176,569.3037 899.4102,510.4087 899.4102,449.7051 C899.4102,389.0015 887.5176,330.1065 864.0635,274.6553 Z M836.9766,613.2983 C815.8086,663.3452 785.502,708.2944 746.8985,746.8984 C708.294,785.5024 663.3448,815.809 613.2979,836.977 C561.4913,858.8896 506.4507,869.9999 449.7051,869.9999 C392.9595,869.9999 337.918,858.8895 286.1113,836.977 C236.0649,815.809 191.1152,785.5024 152.5117,746.8984 C113.9072,708.2944 83.6006,663.3452 62.4326,613.2983 C40.5205,561.4917 29.4101,506.4511 29.4101,449.705 C29.4101,392.9589 40.5205,337.9184 62.4326,286.1117 C83.6006,236.0653 113.9072,191.1156 152.5117,152.5116 C191.1152,113.9076 236.0649,83.601 286.1113,62.433 C337.9179,40.5209 392.959,29.4101 449.7051,29.4101 C506.4512,29.4101 561.4912,40.5209 613.2979,62.433 C663.3448,83.601 708.294,113.9076 746.8985,152.5116 C785.502,191.1156 815.8087,236.0653 836.9766,286.1117 C858.8892,337.9183 870,392.9589 870,449.705 C870,506.4511 858.8892,561.4916 836.9766,613.2983 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i",
    transform: "translate(246.575800, 147.165100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.5078,490.5302 L164.5078,490.7802 C164.2278,490.7001 163.9477,490.62 163.6677,490.5302 L164.5078,490.5302 Z",
    id: "Path",
    fill: "#2C7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.7178,490.5302 L164.7178,490.85 C164.6477,490.83 164.5777,490.81 164.5078,490.7802 C164.2278,490.7001 163.9477,490.62 163.6677,490.5302 L164.7177,490.5302 L164.7178,490.5302 Z",
    id: "Path",
    fill: "#2C7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.7178,490.5302 L164.7178,490.85 C164.6477,490.83 164.5777,490.81 164.5078,490.7802 C164.2278,490.7001 163.9477,490.62 163.6677,490.5302 L164.7177,490.5302 L164.7178,490.5302 Z",
    id: "Path",
    fill: "#2C7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.9578,491.0102 L207.9578,496.4404 C207.9178,496.4502 207.8677,496.4502 207.8277,496.4502 L207.8277,491.0103 L207.9578,491.0103 L207.9578,491.0102 Z",
    id: "Path",
    fill: "#2C7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.7179,489.2001 L164.7179,605.08 L108.0279,605.08 L108.0279,547.1356 L17.0079,547.1356 L17.0079,489.2001 C17.0079,489.2001 164.6478,489.1801 164.7179,489.2001 L164.7179,489.2001 Z",
    id: "Path",
    fill: "#1459FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.2399,451.9199 C390.2799,514.3901 322.3998,545.56 257.6598,548.8501 C254.5199,549.0801 251.08,549.2002 247.5199,549.25 L247.5199,602.96 L190.8197,602.96 L190.9498,491.0103 L190.9498,489.2002 C225.8335,489.2002 247.4998,488.5503 253.1598,487.9502 C312.5299,483.1699 367.7199,445.9004 360.3698,380.3501 C357.83,357.3799 347.8398,332.9404 329.1899,318 C305.01,297.6104 266.2299,292.29 234.29,294.4404 L233.0898,294.5302 L233.08,294.5302 L212.6598,240.9404 L314.08,148.3501 L143.2099,148.3501 L143.2099,344.8003 C143.2099,369.0601 162.9399,388.79 187.1899,388.79 C200.04,388.79 211.4399,385.0302 219.9499,378.3003 L243.58,440.2803 C226.8698,449.1201 207.58,453.98 187.1899,453.98 C126.9899,453.98 78.01,405 78.01,344.8003 L78.01,148.3501 L0,148.3501 L0,91.6602 L82.26,91.6602 L82.26,0 L138.96,0 L138.96,91.6602 L190.68,91.6602 L190.68,0 L247.3699,0 L247.3699,91.6602 L387.1699,91.6602 L406.28,140.9405 L296.3398,241.3101 C308.1999,242.8702 319.9199,245.5401 331.3198,249.4703 C363.78,260.3604 393.99,283.6505 409.4199,314.5201 C430.48,356.4005 436.6098,407.9102 417.24,451.92 L417.2399,451.9199 Z",
    id: "Path",
    fill: "#1459FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTzBtc);
export default __webpack_public_path__ + "static/media/tzBTC.1489d50260e3f81798120f60071550dc.svg";
export { ForwardRef as ReactComponent };